import {styled} from "@mui/material/styles";
import {Dialog, DialogTitle, DialogActions, Button} from "@mui/material";
import colors from "../../themes/colors";

export const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    borderRadius: 13,
    padding: 8,
  }
});

export const StyledDialogTitle = styled(DialogTitle)({
  padding: '0px 24px',
  '& > :first-child': {
    paddingTop: 16,
    fontSize: 18,
    textAlign: 'center',
  }
});

export const StyledDialogActions = styled(DialogActions)({
  justifyContent: 'center',
  paddingTop: 16,
});

export const StyledButton = styled(Button)({
  minWidth: 150,
  backgroundColor: colors.greenFifth,
  borderRadius: 30,
  color: colors.white,
  fontSize: 16,
});
